// React
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Route, Link } from "react-router-dom";
import classNames from "classnames";
import { withTranslation } from "react-i18next";
import history from "routes/history";

// Material UI
import { withStyles } from "@material-ui/core/styles";
import HouseIcon from "../../styles/icons/icon_house.svg";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Icon from "@material-ui/core/Icon";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// redux modules
import {
    TAB_HOME,
    TAB_PROJECT,
    TAB_VERSIONS,
    TAB_TREE,
    selectActiveTab,
    updateTab
} from "redux/modules/tab/change";
import { selectProjectById } from "redux/modules/projects/projects";
import { selectVersions } from "redux/modules/versions/versions";
import {
    updateCurrentTree,
    updateCurrentSavedSet,
    selectCurrentTreeId,
    selectFlatTreeList,
    selectCurrentTreeName
} from "redux/modules/tree/current";
import {
    resetSavedSet,
    selectIsSavedSetDirty
} from "redux/modules/tree/savedset";

import SetConstraintsContainer from "components/SetConstraints/SetConstraintsContainer";
import RunSimulation from "components/RunSimulation/RunSimulation";
import ProjectAddEdit from "components/ProjectAddEdit/ProjectAddEdit";
import DialogComponent from "uiComponents/Dialog/DialogComponent";
import { selectCurrentVersionNum } from "../../redux/modules/versions/current";
import UnSavedChangesDialogCheck from "./UnSavedChangesDialogCheck";

const styles = theme => ({
    container: {
        position: "relative",
        height: 150,
        width: "80%",
        maxWidth: 1200,
        margin: "0 auto",
        paddingLeft: 30,
        paddingRight: 30,
        boxSizing: "border-box"
    },
    background: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: 214,
        zIndex: -10000,
        backgroundSize: "cover",
        backgroundPosition: "top left",
        backgroundColor: "#313A51",
        backgroundImage:
            "url(data:image/svg+xml;base64,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)"
    },
    buttonsContainer: {
        position: "relative"
    },
    buttonsWrapper: {
        position: "absolute",
        right: 0,
        margin: "55px 30px 30px",
        display: "flex"
    },
    tabContainer: {
        position: "absolute",
        bottom: 0
    },
    link: {
        position: "relative",
        display: "inline-block",
        verticalAlign: "top",
        paddingLeft: 50,
        paddingRight: 50,
        lineHeight: "50px",
        height: 50,
        fontSize: 15,
        backgroundColor: theme.status.clay[20],
        color: "#404040",
        textDecoration: "none",
        cursor: "pointer",
        "&:hover": {
            textDecoration: "none"
        },
        "&:before": {
            content: "''",
            position: "absolute",
            right: 0,
            top: 0,
            width: 1,
            height: "100%",
            backgroundColor: "#d8d8d8"
        },
        "&:after": {
            content: "''",
            position: "absolute",
            left: 0,
            bottom: 0,
            height: 1,
            width: "100%",
            backgroundColor: "#d8d8d8"
        }
    },
    linkSelect: {
        paddingLeft: 0,
        paddingRight: 0
    },
    linkActive: {
        backgroundColor: theme.status.clay[10],
        "&:after": {
            backgroundColor: "transparent"
        }
    },
    linkIcon: {
        paddingLeft: 18,
        paddingRight: 18
    },
    linkEdit: {
        paddingRight: 60
    },
    linkEditIcon: {
        position: "absolute",
        top: 1,
        right: 4
    },
    menuItem: {
        position: "relative",
        paddingLeft: 30,
        textAlign: "center",
        fontSize: 14,
        overflow: "hidden"
    },
    menuItemHasChildren: {
        "&:before": {
            content: "''",
            position: "absolute",
            top: 21,
            left: 16,
            width: 1,
            height: "100%",
            backgroundColor: theme.status.clay[50]
        }
    },
    menuItemTree: {
        "&:after": {
            content: "''",
            position: "absolute",
            top: 21,
            left: 14,
            width: 5,
            height: 5,
            borderRadius: "50%",
            backgroundColor: theme.status.clay[50]
        }
    },
    menuItemActive: {
        "&:after": {
            content: "''",
            position: "absolute",
            top: 19,
            left: 14,
            width: 5,
            height: 5,
            borderRadius: "50%",
            backgroundColor: theme.status.midnight[100]
        }
    },
    menuItemSub: {
        paddingLeft: 36,
        fontSize: 12,
        "&:before": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 16,
            width: 1,
            height: "100%",
            backgroundColor: theme.status.clay[50]
        }
    },
    menuItemSubLast: {
        "&:before": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 16,
            width: 1,
            height: "50%",
            backgroundColor: theme.status.clay[50]
        },
        "&:after": {
            content: "''",
            position: "absolute",
            top: 19,
            left: 14,
            width: 5,
            height: 5,
            borderRadius: "50%",
            backgroundColor: theme.status.clay[50]
        }
    }
});

const HomeTabs = ({ onClickTab, classes, activeTab, match, ...otherProps }) => {
    const { url } = match;
    const targetUrl = "/";
    return (
        <Fragment>
            <Link
                className={classNames(
                    { [classes.linkActive]: activeTab === TAB_HOME },
                    classes.link,
                    classes.linkIcon
                )}
                to={targetUrl}
                replace={url === targetUrl}
                onClick={onClickTab(TAB_HOME)}
            >
                <Icon>
                    <img src={HouseIcon} alt="" />
                </Icon>
            </Link>
        </Fragment>
    );
};

const ProjectTabs = ({
    t,
    classes,
    activeTab,
    onClickTab,
    onClickEditIcon,
    match,
    projectName,
    hasVersions,
    history
}) => {
    const { params, url } = match;
    const { projectId } = params;
    const targetUrl = `/project/${projectId}`;
    const versionsTargetUrl = `${targetUrl}/versions`;
    return (
        <Fragment>
            <Link
                className={classNames(
                    { [classes.linkActive]: activeTab === TAB_PROJECT },
                    classes.link,
                    classes.linkEdit
                )}
                to={targetUrl}
                replace={url === targetUrl}
                onClick={onClickTab(TAB_PROJECT, targetUrl, history)}
            >
                {projectName}
                <IconButton
                    aria-label="Edit"
                    aria-haspopup="true"
                    disabled={activeTab !== TAB_PROJECT}
                    className={classes.linkEditIcon}
                    onClick={onClickEditIcon}
                >
                    <MoreVertIcon />
                </IconButton>
            </Link>
            {(hasVersions || activeTab === TAB_VERSIONS) && (
                <Link
                    className={classNames(
                        {
                            [classes.linkActive]: activeTab === TAB_VERSIONS
                        },
                        classes.link
                    )}
                    to={versionsTargetUrl}
                    replace={url === versionsTargetUrl}
                    onClick={onClickTab(
                        TAB_VERSIONS,
                        versionsTargetUrl,
                        history
                    )}
                >
                    {t("project_details.versions")}
                </Link>
            )}
        </Fragment>
    );
};

export const StyledSelect = withStyles({
    root: {
        fontSize: 15,
        lineHeight: "50px"
    },
    select: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 50,
        paddingRight: 50
    },
    icon: {
        position: "relative",
        paddingRight: 10
    }
})(Select);

const VersionTabs = ({
    classes,
    onClickTab,
    onChangeTree,
    activeTab,
    currentTreeId,
    currentTreeName,
    treeDropdownList,
    match
}) => {
    const { params, url } = match;
    const { projectId } = params;
    const targetUrl = `/project/${projectId}`;
    const hasTrees = treeDropdownList && treeDropdownList.length > 0;
    if (activeTab !== TAB_TREE) return null;
    return (
        <Fragment>
            <Link
                className={classNames(
                    {
                        [classes.linkActive]: activeTab === TAB_TREE,
                        [classes.linkSelect]: hasTrees
                    },
                    classes.link
                )}
                to={targetUrl}
                replace={url === targetUrl}
                onClick={event => {
                    event.preventDefault();
                    onClickTab(TAB_TREE);
                }}
            >
                {hasTrees ? (
                    <StyledSelect
                        name="tree"
                        autoWidth={true}
                        disableUnderline
                        disabled={activeTab !== TAB_TREE}
                        onChange={onChangeTree}
                        value={currentTreeId}
                        inputProps={{
                            name: "tree",
                            id: "tree-select"
                        }}
                        renderValue={() => currentTreeName}
                    >
                        {treeDropdownList.map((tree, index, list) => (
                            <MenuItem
                                className={classNames(classes.menuItem, {
                                    [classes.menuItemTree]: !tree.subitem,
                                    [classes.menuItemSub]: tree.subitem,
                                    [classes.menuItemHasChildren]:
                                        !tree.subitem &&
                                        list[index + 1] &&
                                        list[index + 1].subitem,
                                    [classes.menuItemSubLast]:
                                        tree.subitem &&
                                        (index === list.length - 1 ||
                                            (index < list.length - 1 &&
                                                !list[index + 1].subitem)),
                                    [classes.menuItemActive]: tree.active
                                })}
                                key={tree.id}
                                value={[tree.id, tree.parentId]}
                                name={tree.name}
                            >
                                {tree.name}
                            </MenuItem>
                        ))}
                    </StyledSelect>
                ) : (
                    "Tree"
                )}
            </Link>
        </Fragment>
    );
};

const mapStateToProps = (state, ownProps) => ({
    activeTab: selectActiveTab(state),
    project: selectProjectById(state, ownProps),
    version: selectCurrentVersionNum(state),
    hasVersions: selectVersions(state).length > 0,
    currentVersionNum: selectCurrentVersionNum(state),
    currentTreeId: selectCurrentTreeId(state),
    currentTreeName: selectCurrentTreeName(state),
    flatTreeList: selectFlatTreeList(state),
    isSavedSetDirty: selectIsSavedSetDirty(state)
});

const mapDispatchToProps = {
    updateTab,
    updateCurrentTree,
    updateCurrentSavedSet,
    resetSavedSet
};

class Header extends Component {
    static propTypes = {
        active: PropTypes.bool,
        project: PropTypes.object,
        updateTab: PropTypes.func.isRequired,
        resetSavedSet: PropTypes.func.isRequired
    };

    state = {
        isAddModalOpen: false,
        isRecommendationModalOpen: false,
        isUnSavedDialogCheckOpen: false
    };

    handleClickTab = (tabName, targetUrl, history) => event => {
        if (this.props.isSavedSetDirty === true) {
            this.setState({
                isUnSavedDialogCheckOpen: true,
                tabName: tabName,
                targetUrl: targetUrl,
                history: history
            });
            event.preventDefault();
        } else {
            this.props.updateTab(tabName);
        }
    };

    handleClickEdit = () => {
        this.setState({
            isAddModalOpen: true
        });
    };

    handleCloseAddModal = () => {
        this.setState({
            isAddModalOpen: false
        });
    };

    handleCloseUnsavedDialogCheck = () => {
        this.setState({
            isUnSavedDialogCheckOpen: false
        });
    };

    handleDiscardUnSavedChanges = () => {
        const { tabName, targetUrl, history } = this.state;
        this.props.updateTab(tabName);
        history.push(targetUrl);
        this.handleCloseUnsavedDialogCheck();
        this.props.resetSavedSet();
    };

    handleChangeTree = event => {
        const [id, parentId] = event.target.value;
        let treeId = parentId || id;
        let savedSetId = parentId ? id : "default";
        const {
            version,
            project,
            resetSavedSet,
            updateCurrentTree,
            updateCurrentSavedSet
        } = this.props;
        resetSavedSet();
        updateCurrentTree(treeId);
        updateCurrentSavedSet(savedSetId);
        history.push(
            `#/project/${project.id}/versions/${version}/${treeId}/${savedSetId}`
        );
    };

    render() {
        const {
            t,
            classes,
            project,
            hasVersions,
            currentTreeId,
            currentTreeName,
            flatTreeList,
            activeTab
        } = this.props;
        const { isAddModalOpen, isUnSavedDialogCheckOpen } = this.state;
        return (
            <div className={classes.container}>
                <div className={classNames(classes.background, "mui-fixed")} />
                <div className={classes.buttonsContainer}>
                    <Route
                        exact
                        path={[
                            "/project/:projectId",
                            "/project/:projectId/versions"
                        ]}
                        component={props =>
                            (activeTab === TAB_PROJECT ||
                                activeTab === TAB_VERSIONS) && (
                                <div className={classes.buttonsWrapper}>
                                    <SetConstraintsContainer
                                        project={project}
                                        projectId={props.match.params.projectId}
                                    />
                                    <RunSimulation
                                        history={props.history}
                                        projectId={props.match.params.projectId}
                                    />
                                </div>
                            )
                        }
                    />
                </div>
                <div className={classes.tabContainer}>
                    <Route
                        path={[
                            "/project/:projectId",
                            "/project/:projectId/versions",
                            "/project/:projectId/versions/:treeId/:savedSetId"
                        ]}
                        render={props => (
                            <HomeTabs
                                {...props}
                                classes={classes}
                                activeTab={activeTab}
                                onClickTab={this.handleClickTab}
                            />
                        )}
                    />
                    <Route
                        path={[
                            "/project/:projectId",
                            "/project/:projectId/versions",
                            "/project/:projectId/versions/:treeId/:savedSetId"
                        ]}
                        component={props => (
                            <ProjectTabs
                                {...props}
                                t={t}
                                classes={classes}
                                activeTab={activeTab}
                                onClickTab={this.handleClickTab}
                                onClickEditIcon={this.handleClickEdit}
                                projectName={project ? project.name : "Project"}
                                hasVersions={hasVersions}
                            />
                        )}
                    />
                    <Route
                        path={[
                            "/project/:projectId",
                            "/project/:projectId/versions",
                            "/project/:projectId/versions/:treeId/:savedSetId"
                        ]}
                        component={props => (
                            <VersionTabs
                                {...props}
                                classes={classes}
                                activeTab={activeTab}
                                currentTreeId={currentTreeId}
                                currentTreeName={currentTreeName}
                                treeDropdownList={flatTreeList}
                                onClickTab={this.handleClickTab}
                                onChangeTree={this.handleChangeTree}
                            />
                        )}
                    />
                </div>
                <DialogComponent
                    isOpen={isAddModalOpen}
                    onClose={this.handleCloseAddModal}
                    title={t("project_edit_add.edit_title")}
                >
                    <ProjectAddEdit
                        isEdit={true}
                        project={project}
                        onClose={this.handleCloseAddModal}
                    />
                </DialogComponent>
                <UnSavedChangesDialogCheck
                    handleDiscard={this.handleDiscardUnSavedChanges}
                    handleClose={this.handleCloseUnsavedDialogCheck}
                    isOpen={isUnSavedDialogCheckOpen}
                />
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withTranslation()(Header)));
